import { type PropsWithChildren } from "react";

export function Show({
  children,
  when = false,
}: PropsWithChildren<{ when?: boolean }>) {
  if (!when) return null;

  return children;
}
